module.exports = __webpack_public_path__ + "img/text.f57b60a8.png";